export default "__VITE_ASSET__ChvlRWHB__"